import { VoipAgentsProvider } from './UseVoipPulseAgents';
import { VoipPulseCallParticipantsSection } from './VoipPulseCallParticipantsSection';
import { VoipPulseCallSettingsSection } from './VoipPulseCallSettingsSection';

export const VoipPulseTestConfigSection = () => {
    return (
        <VoipAgentsProvider>
            <VoipPulseCallParticipantsSection />
            <VoipPulseCallSettingsSection />
        </VoipAgentsProvider>
    );
};
